import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import PrestationsPage from './pages/PrestationsPage';
import AvisPage from './pages/AvisPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import LegalPages from './pages/LegalPages';
import Maintenance from './pages/Maintenance';

// ============================================================
// MODE MAINTENANCE
// true  → tout le monde voit la maintenance
// false → site normal
// ============================================================
const MAINTENANCE_MODE = false;
// ============================================================

// Bypass secret : accès via ?preview=Admin_fourchette_8360
// Exemple : https://tonsite.com/?preview=Admin_fourchette_8360
const BYPASS_KEY = 'Admin_fourchette_8360';
const isBypass = typeof window !== 'undefined' &&
  new URLSearchParams(window.location.search).get('preview') === BYPASS_KEY;

function App() {
  if (MAINTENANCE_MODE && !isBypass) {
    return <Maintenance />;
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/prestations" element={<PrestationsPage />} />
          <Route path="/avis" element={<AvisPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/mentions-legales" element={<LegalPages type="mentions" />} />
          <Route path="/confidentialite" element={<LegalPages type="confidentialite" />} />
          <Route path="/maintenance" element={<Maintenance />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
